<template>
  <span class="noWrap">
    {{ setLabel }}
  </span>
</template>

<script>
import ArchivesTypes from '@/app/arch/enums/ArchivesTypes';

export default {
  name: 'ArchivesTypeColumn',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    types: ArchivesTypes,
  }),
  computed: {
    setLabel() {
      const type = this.getType;

      return type ? type.text : this.value;
    },
    getType() {
      return this.types.find(
        (type) => type.value === this.value,
      );
    },
  },
};
</script>
